/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CriterioSpareggio } from './criterio-spareggio';
import { DirezioneOrdinamento } from './direzione-ordinamento';


export interface CriterioSpareggioForm { 
    criterio: CriterioSpareggio;
    parametro?: string;
    direzione?: DirezioneOrdinamento;
}



